import { InputLabel, styled } from '@mui/material';

export const StyledInputLabel = styled(InputLabel)({
  position: 'static',
  transform: 'none',
  height: 20,
  fontSize: 13,
  fontWeight: 700,
  color: '#292D35',
  marginBottom: 4,
  '& .MuiFormLabel-asterisk': {
    color: '#D82C0D',
    fontWeight: 500,
  },
});
